// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ev48","controls":"styles_controls__1biGb","charLimit":"styles_charLimit__2Ygvx","input":"styles_input__2gbQn","send":"styles_send__nwQfi"};